// 表示/非表示切り替え
import commonClass from "./commonClass";

export default class truncateClass extends commonClass {
  // コンストラクタ
  constructor() {
    super();
    this._getSuper();
    this._classValiableDefine();

    this._init();
  }

  // 親classから変数を取得してくる
  _getSuper() {
  }
  // class変数定義
  _classValiableDefine() {
    this._$trunctLine1 = $('.js-trunct-line-1');
    this._$trunctLine2 = $('.js-trunct-line-2');
    this._$trunctLine3 = $('.js-trunct-line-3');
  }


  // 初期化用関数
  _init() {
    this._main();
  }

  // リサイズ用関数
  _resize() {
  }

  // メイン処理
  _main() {
    var cls = this;

    // 1行
    var opt_truncate_line_1 = {
      $tgt: cls._$trunctLine1,
      line: 1,
      resizeFunc: {
        common: "recalc"
      }
    };
    this._truncateLines(opt_truncate_line_1);

    // 2行
    var opt_truncate_line_2 = {
      $tgt: cls._$trunctLine2,
      line: 2,
      resizeFunc: "recalc"
    };
    this._truncateLines(opt_truncate_line_2);

    // 3行
    var opt_truncate_line_3 = {
      $tgt: cls._$trunctLine3,
      line: 3,
      resizeFunc: "recalc"
    };
    this._truncateLines(opt_truncate_line_3);
  }

  _truncateLines(opt) {
    var truncate = Truncator.truncate;
    var $tgt = opt.$tgt;
    var hasResizeFunc = "resizeFunc" in opt;
    var resizeFunc = (hasResizeFunc) ? opt.resizeFunc : null;

    var len = $tgt.length;
    for (var i = 0; i < len; i++) {
      // クロージャにするため即時関数で実行
      (function (idx) {
        var el = $tgt[idx];
        var truncator_text = truncate(
          el,
          $(el).text(),
          {
            line: opt.line,
            ellipsis: "…"
          }
        );

        if (hasResizeFunc) {
          $(window).on('resize', function () {
              if (resizeFunc === "recalc") truncator_text.recalc();
              if (resizeFunc === "restore") truncator_text.restore();
          });
        }
      })(i);
    }
  }
}